module.exports = __webpack_public_path__ + "img/img_2.1b4a771c.jpg";